import { Component, OnInit } from '@angular/core';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-protocolos-diarios',
  templateUrl: './protocolos-diarios.component.html',
  styleUrls: ['./protocolos-diarios.component.scss']
})
export class RelatorioProtocolosDiariosComponent implements OnInit{

  dataHoje = '';
  public listaArea: Area[] = [];


  constructor(
    private areaService: AreaService
  ) {
    this.dataHoje = new Date().toISOString().split('T')[0];
  }

  ngOnInit() {
    this.areaService.obterLista("", 1).toPromise()
    .then(data => {
          this.listaArea = data;
        },
        (erro) => {
          console.error('Erro ao obter a lista de áreas:', erro);
        }
    );
  }

}
